<template>
    <span
        class="contact_name flex items-center gap-1.5 last-of-type:mb-0 py-0.5"
        :class="[
            notMb ? '' : 'mb-[0.6875rem]',
            isFull ? 'w-full' : '',
            // isLarge ? '!block' : '',
            screenSize === 'sm' || screenSize === 'xs' ? 'mobile_view' : '',
        ]"
    >
        <!-- {{ data.length }} -->
        <div class="flex items-center contact_name_icon" @click="emits('handleClick', data)">
            <template v-for="(contact, contactIndex) in data" :key="contactIndex">
                <!-- ml-[-1rem] -->
                <span
                    v-if="contactIndex <= 2"
                    :class="[
                        unReadMessage && contactIndex === 0 && data.length > 1 ? 'outboard' : '',
                        `z-[${3 - contactIndex}]`,
                        contactIndex > 0 ? 'ml-[-8px]' : '',
                    ]"
                >
                    <img
                        v-if="contact.image_path"
                        :src="contact.image_path"
                        class="rounded-full border-gray-150 border"
                        :class="[isLarge ? 'h-8 w-8 !text-[16px]' : 'h-6 w-6 !text-[14px]']"
                    />

                    <span
                        v-else
                        class="name_icon__letter_text uppercase"
                        :class="[
                            contact.badge,
                            isLarge ? 'h-8 w-8 !text-[16px]' : 'h-6 w-6 !text-[14px]',
                            showInteractions
                                ? 'hover:border hover:scale-125 hover:border-green-600 transition-transform duration-300'
                                : '',
                            // isSmall ? 'w-4 h-4 text-[0.625rem]' : 'h-8 w-8 min-w-[32px]',
                            // isLarge ? '!h-20 !w-20 block !text-[38px] !leading-[45px] mb-2' : 'h-8 w-8',
                            // isDetail ? '!h-[4.75rem] !w-[4.75rem] !mr-0' : 'h-8 w-8',
                        ]"
                    >
                        {{ contact.first_name && contact.first_name.charAt(0)
                        }}{{ contact.last_name ? contact.last_name.charAt(0) : "" }}
                        <!-- <span class="online_indicator" ></span> -->
                    </span>
                </span>
            </template>
            <span v-if="data.length >= 4" class="ml-[-8px] z-[4]">
                <span
                    class="name_icon__letter_text uppercase bg-salmon-500"
                    :class="[
                        isLarge ? 'h-8 w-8 !text-[16px]' : 'h-6 w-6 !text-[14px]',
                        // isSmall ? 'w-4 h-4 text-[0.625rem]' : 'h-8 w-8 min-w-[32px]',
                        // isLarge ? '!h-20 !w-20 block !text-[38px] !leading-[45px] mb-2' : 'h-8 w-8',
                        // isDetail ? '!h-[4.75rem] !w-[4.75rem] !mr-0' : 'h-8 w-8',
                    ]"
                >
                    <span class="text-black-500">+{{ data.length - 3 }}</span>
                    <span class="online_indicator !border-black-500"></span>
                </span>
            </span>
        </div>
        <span class="name_icon__text" :class="search ? '!leading-[16px]' : ''" v-if="isShow">
            <i class="not-italic block truncate" :class="[type ? 'font-bold' : '']">{{
                formatNames(data) + `${type ? ` - ${type}` : ""}`
            }}</i>
            <div class="text-xs pr-[0.5rem] font-bold">{{ title }}</div>
            <span
                class="text-xs not-italic font-light leading-[normal] block text-black-600 board_name"
                v-if="ContactBoardName && !search"
                >{{ ContactBoardName }}
            </span>
            <span
                class="text-xs not-italic font-normal leading-[normal] text-black-600 board_name"
                :class="[isBlock ? 'flex flex-col-reverse gap-0.5 mt-1' : '']"
                v-if="search"
            >
                <span>{{ data[0].email }}</span> {{ !isBlock ? "-" : "" }}
                <span>{{ data[0].phone1[0].phone.phoneNumber }}</span>
            </span>
        </span>
    </span>
</template>
<script setup>
// Vue imports
import { ref } from "vue";

const emits = defineEmits(["handleClick"]);

// Props
const props = defineProps({
    data: {
        type: Array,
        default: () => [],
        required: true,
    },
    nameArray: {
        type: Array,
        default: () => [],
    },
    nameText: {
        type: String,
        default: "",
    },
    nameTextClass: {
        type: String,
        default: "",
    },
    nameLetter: {
        type: String,
        default: "",
    },
    notMb: {
        type: Boolean,
        default: false,
    },
    lastNameLetter: {
        type: String,
        default: "",
    },
    ContactBoardName: {
        type: String,
        default: "",
    },
    isMedium: {
        type: Boolean,
        default: false,
    },
    isLarge: {
        type: Boolean,
        default: false,
    },
    color: {
        type: String,
        default: "",
    },
    badgeClass: {
        type: String,
        default: "",
    },
    isOnline: {
        type: Boolean,
        default: false,
    },
    isFull: {
        type: Boolean,
        default: true,
    },
    email: {
        type: String,
        default: "",
    },
    isSmall: {
        type: Boolean,
        default: false,
    },
    isDetail: {
        type: Boolean,
        default: false,
    },
    screenSize: {
        type: String,
        default: "",
    },
    isShow: {
        type: Boolean,
        default: true,
    },
    search: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: "",
    },
    showInteractions: {
        type: Boolean,
        default: false,
    },
    isBlock: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: "",
    },
});

const unReadMessage = ref(false);

function formatNames(namesArray) {
    if (!namesArray || namesArray.length === 0) {
        return "";
    }

    // Extract full names from the array, handling null/undefined names
    const names = namesArray
        .map((name) => {
            const firstName = name.first_name || ""; // Default to empty string
            const lastName = name.last_name || ""; // Default to empty string
            return `${firstName} ${lastName}`.trim(); // Trim any extra spaces
        })
        .filter((fullName) => fullName); // Remove any empty names

    // If no valid names exist, return an empty string
    if (names.length === 0) {
        return "";
    }

    // If there are more than 3 names, limit to 3 and add '...'
    if (names.length > 3) {
        return `${names.slice(0, 3).join(", ")}...`;
    }

    // If there are exactly 3 names, join them properly
    if (names.length === 3) {
        return `${names[0]}, ${names[1]} & ${names[2]}`;
    }

    // For 2 or fewer names, join with ' & '
    return names.join(" & ");
}
</script>
<style scoped>
.name_icon__letter_text {
    @apply inline-flex align-top items-center justify-center rounded-full text-white relative text-base font-normal;
}
.name_icon__text {
    @apply text-sm leading-[22px] font-medium text-black-600  max-w-[85%] whitespace-nowrap overflow-x-hidden text-ellipsis dark:text-white transition-all;
}
.contact_name_details .name_icon__text {
    @apply text-lg font-semibold leading-[22px];
}
.online_indicator {
    @apply w-[9px] h-[9px] border-2 rounded-full bg-green-500 border-white absolute -top-[2px] -right-[1.5px];
}
.outboard {
    @apply p-[1px] rounded-[99px] border-solid  border-blue-500 border-2;
}
.mobile_view {
    @apply !flex-col;
}
.mobile_view .name_icon__text {
    @apply text-center;
}
.mobile_view .name_icon__letter_text {
    @apply !w-[89px] !h-[89px] !text-[32px] border-0;
}
.mobile_view .online_indicator {
    @apply !w-[20px] !h-[20px];
}
.mobile_view .contact_name_icon {
    @apply !mb-3;
}
.mobile_view .contact_name_icon > span:first-child {
    @apply !ml-0;
}
.mobile_view .contact_name_icon > span {
    @apply ml-[-69px];
}
.mobile_view .name_icon__text .board_name {
    @apply font-medium text-gray-500;
}
</style>
